module.exports = __webpack_public_path__ + "static/img/每日荐读.06be340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/每日荐读.png
// module id = sVyq
// module chunks = 1